import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { styled } from '@mui/material';

import useStyles from './styles';

interface CollappseContainerProps {
  onClick?: (args?: unknown) => void;
  isVisible: boolean;
}

const CollapseContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  position: 'sticky',
  top: '0',
});

const ToggleDrawer = ({ onClick, isVisible }: CollappseContainerProps): JSX.Element => {
  const styles = useStyles();

  return (
    <CollapseContainer>
      {isVisible ? <ChevronLeft className={styles.icon} onClick={onClick} /> : <ChevronRight className={styles.icon} onClick={onClick} />}
    </CollapseContainer>
  );
};

export default ToggleDrawer;
